import { ChartCurve } from '@base/@types/components/Layout/Graphic/Info'
import { IGraphicResponse } from '@base/@types/providers/Mrp/PurchaseProvider'

const getDescriptionMonth = (month: number) => {
  switch (month) {
    case 0:
      return 'Jan'
    case 1:
      return 'Fev'
    case 2:
      return 'Mar'
    case 3:
      return 'Abr'
    case 4:
      return 'Mai'
    case 5:
      return 'Jun'
    case 6:
      return 'Jul'
    case 7:
      return 'Ago'
    case 8:
      return 'Set'
    case 9:
      return 'Out'
    case 10:
      return 'Nov'
    case 11:
      return 'Dez'
    default:
      return null
  }
}

export const dailySeries = (data: IGraphicResponse) => {
  return [
    {
      name: 'Vendas',
      type: 'column',
      data: data.sales.map(item => item.valor),
      showZero: false
    },
    {
      name: 'Estoque',
      type: 'area',
      data: data.storage.map(item => item.valor),
      showZero: false
    }
  ]
}

export const dailyChart = (data: IGraphicResponse, title: string) => {
  return {
    title: {
      text: `MRP ${title} (Diário)`
    },
    stroke: {
      curve: ChartCurve.straight
    },

    markers: {
      size: 0,
      hover: {
        sizeOffset: 3
      }
    },
    chart: {
      id: 'chart2',
      animations: {
        enabled: false
      },
      zoom: {
        autoScaleYaxis: true
      },
      dropShadow: {
        enabled: false
      },
      annotations: {
        yaxis: [
          {
            y: 10
          }
        ]
      }
    },

    dataLabels: {
      enabled: false,
      enabledOnSeries: [1]
    },
    // labels,
    xaxis: {
      tickAmount: 10,

      labels: {
        rotate: -45
      },
      categories: data.storage.map(item => {
        const date = new Date(item.data)
        const day = date.getUTCDate()
        const month = date.getMonth()
        const year = date.getFullYear()
        if (month < 9) {
          return `${day < 10 ? '0' + day : day}/0${month + 1}/${year}`
        }

        return `${day < 10 ? '0' + day : day}/${month + 1}/${year}`
      })
      // categories: data.storage.map(item => {
      //   const month = new Date(item.data).getMonth()

      //   return getDescriptionMonth(month)
      // })
    }
  }
}

export const montlySeries = (data: IGraphicResponse) => {
  return [
    {
      name: 'Vendas',
      type: 'column',
      data: data.sales.map(item => item.valor)
    },
    {
      name: '',
      type: 'column',
      data: []
    }
  ]
}

export const montlyChart = (data: IGraphicResponse, title: string) => {
  return {
    title: {
      text: `MRP ${title} (Mensal)`
    },
    stroke: {
      curve: ChartCurve.straight
    },

    markers: {
      size: 0,
      hover: {
        sizeOffset: 3
      }
    },
    chart: {
      id: 'chart2',
      animations: {
        enabled: false
      },
      zoom: {
        autoScaleYaxis: true
      },
      dropShadow: {
        enabled: false
      }
    },

    dataLabels: {
      enabled: false,
      enabledOnSeries: [1]
    },
    // labels,
    xaxis: {
      x: new Date('14 Nov 2021').getTime(),
      tickAmount: 8,
      labels: {
        rotate: 0
      },
      categories: data.sales.map(item => {
        const month = new Date(item.data).getMonth()

        return (
          getDescriptionMonth(month) +
          '/' +
          new Date(item.data).getUTCFullYear()
        )
      })
    },
    yaxis: [
      {
        title: {
          text: 'Vendas'
        }
      }
    ]
  }
}
